import { Select, SelectProps } from "@material-ui/core";
import { useSetupLinkStyles } from "@ui/setup-scheduling-link";
import React from "react";

const SetupLink = ({ children, ...selectProps }: SelectProps) => {
  const classes = useSetupLinkStyles();

  return (
    <Select
      autoWidth
      className={classes.select}
      disableUnderline
      MenuProps={{
        disableScrollLock: true,
        PaperProps: {
          style: { maxHeight: 270 },
        },
      }}
      variant="filled"
      {...selectProps}
    >
      {children}
    </Select>
  );
};

export default SetupLink;
